import type { PollScoreBar } from '@/containers/DevToolsNew/CommunicationBoard/PollResults/types'
import { BarCount, BarFill, BarLabel, BarRow, BarTrack, FaceSwatch } from './styled-components'

interface PollScoreBarRowProps {
  bar: PollScoreBar
}

const PollScoreBarRow = ({ bar: { Icon, colorKey, label, count, share } }: PollScoreBarRowProps) => (
  <BarRow>
    <FaceSwatch $colorKey={colorKey}>
      <Icon size={18} />
    </FaceSwatch>
    <BarLabel>{label}</BarLabel>
    <BarTrack>
      <BarFill $colorKey={colorKey} $share={share} />
    </BarTrack>
    <BarCount>
      {count} · {share} %
    </BarCount>
  </BarRow>
)

export default PollScoreBarRow
